// A chave do PostHog é validada por FORMATO, não por presença.
//
// A classe que este arquivo fecha nasceu em três formas no mesmo dia (15/08,
// task b48e957d): o .env.example carregava VITE_POSTHOG_KEY="" como template
// — virou o .env do Mac de build e o app nativo ficou MUDO no PostHog,
// provavelmente desde sempre; um placeholder com valor (COLE_A_CHAVE_AQUI)
// PASSAVA pelo guard `!KEY` — o init rodava, o PostHog descartava em silêncio
// e o alarme não disparava; e o próprio alarme só detectava AUSÊNCIA.
//
// O formato real, medido na chave do projeto (a chave em si NUNCA entra em
// arquivo versionado): 48 chars, prefixo phc_ + 44 alfanuméricos. Cloud e
// self-host usam o mesmo prefixo phc_. O piso de 32 no sufixo é folgado de
// propósito: pega "" (missing), placeholder e phc_ truncada, sem quebrar por
// variação pequena de tamanho.
//
// CONTRATO DE FALSO POSITIVO, decidido de caso pensado: se o PostHog um dia
// mudar o formato, uma chave BOA será tratada como inválida — analytics
// desligado + warn + issue no Sentry dizendo "invalid". Alarme falso em vez
// de silêncio; o custo é ajustar a regex abaixo (uma linha) com o issue
// apontando exatamente o caso.

export type PosthogKeyProblem = "missing" | "invalid";

/** null = chave plausível; "missing" = ausente/vazia; "invalid" = tem valor mas não é chave. */
export function posthogKeyProblem(key: string | undefined): PosthogKeyProblem | null {
  if (!key) return "missing";
  if (!/^phc_[A-Za-z0-9]{32,}$/.test(key)) return "invalid";
  return null;
}
